var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import SectionMenu from "./SectionMenu.vue";
import Component from 'vue-class-component';
import HomeService from '../../api/HomeService';
import { mapActions } from "vuex";
import Empty from "./Empty.vue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.list = [];
        _this.businessId = [];
        return _this;
    }
    default_1.prototype.created = function () {
        var _this = this;
        this.service = HomeService.getInstance();
        this.service.getJoinCustomer().then(function (res) {
            if (res.data.success) {
                _this.list = Array.isArray(res.data.data) ? res.data.data : [];
                _this.businessId = _this.list.map(function (item) {
                    return item.business_id;
                });
                if (_this.list.length == 0) {
                    _this.$emit('hiddenJoinModel');
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    default_1.prototype.toCertificateDetail = function () {
        this.$emit("to-join-detail", this.businessId.join(','));
    };
    default_1 = __decorate([
        Component({
            components: {
                SectionMenu: SectionMenu,
                Empty: Empty
            },
            methods: __assign({}, mapActions(["updateHomeShow"])),
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
